import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { Customer } from "@app/core/models/customer.model";
import { ActivatedRoute, Router } from "@angular/router";
import { BooleanInput } from "@angular/cdk/coercion";
import { CustomerService } from "@app/core/services/customer.service";
import { UserAlertService } from "@app/shared/services/user-alert.service";
import { CustomerAddress } from '@app/core/models/customer-address.model';
import { Country } from '@app/core/models/country.model';
import { DialogData } from '@app/shared/models/dialog-data';
import { DialogAction } from '@app/shared/models/dialog-action';
import { DialogComponent } from '@app/shared/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-customer-address',
  templateUrl: './customer-address.component.html',
  styleUrls: ['./customer-address.component.css']
})
export class CustomerAddressPageComponent implements OnInit{
	@Input()
	parentForm!: FormGroup;
	private _initialDetails?: CustomerAddress = undefined;
	private _readonly: BooleanInput = true;
	customer?: Customer;
	customerAddress?: CustomerAddress;
	selections?: SelectionModel<CustomerAddress>;
	agency?: Customer;
	form!: FormGroup;
	id: FormControl;
	address: FormControl;
	description: FormControl;
	city: FormControl;
	zipcode: FormControl;
	province: FormControl;
	country: FormControl;

	isReadOnly()  {
		return false;
	}

	isValid() {
		return this?.form?.status == "VALID";
	}

	initDefaults() {
			// return any values back to initial states
			if (this.form && this != undefined && this.customerAddress != undefined) {
				this.setFormValueIfNotEmpty("id", this.customerAddress.id);
				this.setFormValueIfNotEmpty("address", this.customerAddress.address);
				this.setFormValueIfNotEmpty("description", this.customerAddress.description);
				this.setFormValueIfNotEmpty("city", this.customerAddress.city);
				this.setFormValueIfNotEmpty("zipcode", this.customerAddress.zipCode);
				this.setFormValueIfNotEmpty("province", this.customerAddress.province);
				this.setFormValueIfNotEmpty("country", this.customerAddress.country);
			}
	}

	public countries: Country[] = [];

	set Country(code : string) {
		this.setFormValueIfNotEmpty("country",code);
	}
	get Country() {
		return this.getFormValueIfNotEmpty("country");
	}


	clickEditButton() {
		this._readonly = !this._readonly;
		if (this._readonly) {
			this.initDefaults();
		}

	}

	constructor(private formBuilder: FormBuilder,
				private _route: ActivatedRoute,
				private _router: Router,
				private _userAlertService: UserAlertService,
				private _dialog: MatDialog,
				private _customerService: CustomerService
		) {
		this.id = this.formBuilder.control(this._initialDetails?.id || "");
		this.address = this.formBuilder.control(this._initialDetails?.address || "", [Validators.required,Validators.maxLength(40)]);
		this.description = this.formBuilder.control(this._initialDetails?.description || "", [Validators.required,Validators.maxLength(40)]);
		this.city = this.formBuilder.control(this._initialDetails?.city || "", [Validators.required,Validators.maxLength(40)]);
		this.province = this.formBuilder.control(this._initialDetails?.province || "", [Validators.required,Validators.maxLength(40)]);
		this.zipcode = this.formBuilder.control(this._initialDetails?.zipCode || "", [Validators.required,Validators.maxLength(12)]);
		this.country = this.formBuilder.control(this._initialDetails?.country || "", [Validators.required,Validators.maxLength(2)]);
		const nav = this._router.getCurrentNavigation();
		if (nav && nav.extras && nav.extras.state) {
			this.customer = nav.extras.state['customer'];
			this.agency = nav.extras.state['agency'];
			this.selections = nav.extras.state['selections'];
			this.countries = nav.extras.state['countries'];
			this.customerAddress = nav.extras.state['address'];
		}
		this.form = new FormGroup({});
		this._dialog = _dialog;
	}

	getCustomerAddressDetails(): CustomerAddress {

		const customerAddressDetails = new CustomerAddress();

		customerAddressDetails.id = this.getFormValueIfNotEmpty('id');
		customerAddressDetails.address = this.getFormValueIfNotEmpty('address');
		customerAddressDetails.description = this.getFormValueIfNotEmpty('description');
		customerAddressDetails.city = this.getFormValueIfNotEmpty('city');
		customerAddressDetails.zipCode = this.getFormValueIfNotEmpty('zipcode');
		customerAddressDetails.province = this.getFormValueIfNotEmpty('province');
		customerAddressDetails.country = this.getFormValueIfNotEmpty('country');

		return customerAddressDetails;
	}

	ngOnInit(): void {
		//this.form = this.parentForm;
		this.form.addControl("id", this.id);
		this.form.addControl("address", this.address);
		this.form.addControl("description", this.description);
		this.form.addControl("city", this.city);
		this.form.addControl("zipcode", this.zipcode);
		this.form.addControl("province", this.province);
		this.form.addControl("country", this.country);
		if (this.customer) {
			this._initialDetails = this.customer;
			this.initDefaults();
		}
	}

	private setFormValueIfNotEmpty(fieldName: string, fieldValue?: string) {
		if (this.form && fieldValue) {
			this.form.controls[fieldName].setValue(fieldValue);
		}
	}
	private getFormValueIfNotEmpty(fieldName: string)  {
		return this.form?.controls[fieldName]?.value;
	}

	modifyCustomerAddress() {
		if (this != undefined && this.customer != undefined) {
			const customerAddress = this.getCustomerAddressDetails();
			var modified = false;
			// make sure there is an address collection.
			if (this.customer?.addresses == undefined ) {
				if (this && this.customer) {
				this.customer.addresses = [];
				}
			}
			if (this.selections == undefined) {
				this.customer.addresses?.push(customerAddress);
				modified = true;
			}
			else if (this && this.customer && this.customer.addresses) {
				for(var index = 0; index < this.customer.addresses.length; index++) {
					if (this.customer.addresses[index].id == customerAddress.id) {
						this.customer.addresses[index] = customerAddress;
						modified = true;
						break;
					}
				}
			}
			if (modified) {
				this._customerService.createOrUpdateCustomer(this?.agency?.id, this.customer).
				subscribe(
					updatedCustomer => {
						this._router.navigate(["advertiser"], { state: { customer: updatedCustomer, agency: this.agency } });
					},
					// TODO NOT SURE WHAT WE WANT TO DO FOR ERROR HANDLING
					error => { this._userAlertService.error("FAILED")});

			} else {
				this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
			}
		}
	}

	confirmDeleteCustomerAddress(): void {
		const submitActionId = "delete";
		const dialogData = new DialogData();
		dialogData.messageKey = "CUSTOMER_DETAILS.DELETE_CONFIRMATION_MESSAGE.CONFIRM_REMOVE_ADDRESS";
		dialogData.actions = [
			new DialogAction(submitActionId, "ACTION_BUTTON_LABELS.DELETE", true),
			new DialogAction("", "ACTION_BUTTON_LABELS.CANCEL", false),
		];
		const dialogRef = this._dialog.open(DialogComponent, { data: dialogData	});
		dialogRef.afterClosed().subscribe({
			next: (actionId: string) => {
				if (actionId === submitActionId) this.deleteCustomerAddress();
			}
		});
	}


	deleteCustomerAddress() {
		if (this != undefined && this.customer != undefined && this.customerAddress != undefined && this.customer.addresses != undefined) {
			var modified = false;
			// any contacts we wish to remove... remove them
			const internet  = this.customerAddress;
			for(var index = this.customer.addresses.length-1; index >= 0; index--) {
				if (this.customer.addresses[index].id == internet?.id) {
					//this.customer.contacts[index].id = "DELETE + "
					this.customer.addresses.splice(index,1);
					modified = true;
					break;
				}
			}
			// once removed we then delete them from the customer.
			if (modified) {
					this._customerService.createOrUpdateCustomer(this?.agency?.id, this.customer).
					subscribe(
						updatedCustomer => {
							this.customer = updatedCustomer;
							this._router.navigate(["advertiser"], { state: { customer: updatedCustomer, agency: this.agency } });
						},
						// TODO NOT SURE WHAT WE WANT TO DO FOR ERROR HANDLING
						error => { this._userAlertService.error("FAILED:${error}")});
			} else {
				this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
			}
		}
	}

	closeCustomerAddress() {
		if (this && this.customer) {
			this._router.navigate(["advertiser"], { state: { customer: this.customer, agency: this.agency } });
		}
	}

}

